import script from "./MenuTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuTab.vue?vue&type=script&setup=true&lang=js"

import "./MenuTab.vue?vue&type=style&index=0&id=0acb8f0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0acb8f0f"]])

export default __exports__